import { RequestBuilder } from '../request_builder'

export class WalletRequestBuilder extends RequestBuilder {
  constructor (serverUrl) {
    super(serverUrl)
    this.segment = 'wallets'
  }

  factors () {
    this.filters.push('factors')
    return this
  }

  factorId (id) {
    this.filters.push('factors')
    this.filters.push(id)
    return this
  }

  lost () {
    this.filters.push('lost_tfa')
    return this
  }

  reset () {
    this.filters.push('recover_tfa')
    return this
  }

  verification () {
    this.filters.push('verification')
    return this
  }

  walletId (id) {
    this.filters.push(id)
    return this
  }
}



// WEBPACK FOOTER //
// ./src/js/builders/request_builder/modules/wallet_request_builder.js